import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Line from '@ant-design/charts/es/line';
import {customerStatistic, groupStatistic} from '@/api/customer';
import {Spin, Empty, notification} from 'antd';
import dayjs from 'dayjs';

function StatisticChart({searchParams, type = 'customer'}) {
    useEffect(() => {
        init();
    }, [searchParams]);

    const [behaviorDatas, setBehaviorDatas] = useState([]);
    const [loading, setLoading] = useState(false);

    function renderCharts() {
        let data = [];
        let config = {
            xField: 'statTime',
            yField: 'value',
            seriesField: 'name',
            isGroup: 'true',
        };
        // 变换数据格式
        if (type === 'customer') {
            if (behaviorDatas.length > 0) {
                behaviorDatas.forEach(item => {
                    //1630512000
                    const {
                        avgReplyTime,
                        chatCnt,
                        messageCnt,
                        newApplyCnt,
                        newContactCnt,
                        replyPercentage,
                        statTime,
                    } = item;
                    const time = dayjs(statTime * 1000).format('YYYY-MM-DD');
                    // 平均首次回复时长
                    data.push({
                        name: '平均首次回复时长',
                        value: avgReplyTime,
                        statTime: time,
                    });
                    // 聊天总数
                    data.push({
                        name: '聊天总数',
                        value: chatCnt,
                        statTime: time,
                    });
                    // 聊天总数
                    data.push({
                        name: '发送消息数',
                        value: messageCnt,
                        statTime: time,
                    });
                    // 发起申请数
                    data.push({
                        name: '发起申请数',
                        value: newApplyCnt,
                        statTime: time,
                    });
                    // 新增客户数
                    data.push({
                        name: '新增客户数',
                        value: newContactCnt,
                        statTime: time,
                    });
                    // 已回复聊天占比
                    data.push({
                        name: '已回复聊天占比',
                        value: replyPercentage,
                        statTime: time,
                    });
                });
            }
        } else {
            if (behaviorDatas.length > 0) {
                behaviorDatas.forEach(item => {
                    //1630512000
                    const {statTime, statisticGroupByDayItemData} = item;
                    const time = dayjs(statTime * 1000).format('YYYY-MM-DD');
                    const {
                        chatHasMsg,
                        chatTotal,
                        memberHasMsg,
                        memberTotal,
                        migrateTraineeChatCnt,
                        msgTotal,
                        newChatCnt,
                        newMemberCnt,
                    } = statisticGroupByDayItemData;
                    // 新增客户群数量
                    data.push({
                        name: '新增客户群数量',
                        value: newChatCnt,
                        statTime: time,
                    });
                    // 客户群总数量
                    data.push({
                        name: '客户群总数量',
                        value: chatTotal,
                        statTime: time,
                    });
                    // 有发过消息的客户群数量
                    data.push({
                        name: '有发过消息的客户群数量',
                        value: chatHasMsg,
                        statTime: time,
                    });
                    // 客户群新增群人数
                    data.push({
                        name: '客户群新增群人数',
                        value: newMemberCnt,
                        statTime: time,
                    });
                    // 客户群总人数
                    data.push({
                        name: '客户群总人数',
                        value: memberTotal,
                        statTime: time,
                    });
                    // 有发过消息的群成员数
                    data.push({
                        name: '有发过消息的群成员数',
                        value: memberHasMsg,
                        statTime: time,
                    });
                    // 客户群消息总数
                    data.push({
                        name: '客户群消息总数',
                        value: msgTotal,
                        statTime: time,
                    });
                });
            }
        }

        config.data = data;
        return data.length > 0 ? <Line {...config} /> : <Empty />;
    }

    function init() {
        setLoading(true);
        if (type === 'customer') {
            customerStatistic(searchParams).then(res => {
                if (res.data.errcode === 0) {
                    setBehaviorDatas(res.data.behaviorDatas);
                } else {
                    notification.error({
                        message: '企业微信接口查询失败',
                        description: (
                            <>
                                <p>{'错误码：' + res.data.errcode}</p>
                                <a
                                    href={
                                        'https://open.work.weixin.qq.com/devtool/query?e=' +
                                        res.data.errcode
                                    }
                                    target="_blank"
                                >
                                    点击查询具体错误
                                </a>
                            </>
                        ),
                    });
                    setBehaviorDatas([]);
                }
                setLoading(false);
            });
        } else {
            groupStatistic(searchParams).then(res => {
                if (res.data.errcode === 0) {
                    setBehaviorDatas(res.data.items);
                } else {
                    notification.error({
                        message: '企业微信接口查询失败',
                        description: (
                            <>
                                <p>{'错误码：' + res.data.errcode}</p>
                                <a
                                    href={
                                        'https://open.work.weixin.qq.com/devtool/query?e=' +
                                        res.data.errcode
                                    }
                                    target="_blank"
                                >
                                    点击查询具体错误
                                </a>
                            </>
                        ),
                    });
                    setBehaviorDatas([]);
                }
                setLoading(false);
            });
        }
    }

    return (
        <div style={{width: '90%'}}>
            <Spin spinning={loading}>{renderCharts()}</Spin>
        </div>
    );
}

StatisticChart.propTypes = {
    searchParams: PropTypes.shape({
        startTime: PropTypes.number.required,
        endTime: PropTypes.number.required,
        userId: PropTypes.string.required,
    }),
};

export default StatisticChart;
